import React from 'react';
import './styles.scss';

const CustomLoader = ({width = 50}) => {
  return (
    <div className='custom_loader'>
      <div className='customLoader' style={{width: `${width}px`}}></div>
    </div>
  );
};

export default CustomLoader;
